import { Listeners, onSortGoTo, formatMoney } from './utils.js';
import { CosPaginatedGrid } from './common.js';

class CosCollectionGrid extends CosPaginatedGrid {
  // connectedCallback() {
  //   super.connectedCallback();
  // }

  // disconnectedCallback() {
  //   super.disconnectedCallback();
  // }

  handleFetchLinkResult(result) {
    this.resetStorage();

    const wrapper = new DOMParser().parseFromString(result, 'text/html');

    this.switchGridList(wrapper);
    this.switchFilters(wrapper);
    this.switchSearchTitle(wrapper);

    this.handleLoadMore();
    this.updateLoading(false);

    onSortGoTo();
  }

  async onPriceFiterChange(url) {
    const result = await this.getPage(url);
    
    window.history.replaceState({}, '', url);
    this.handleFetchLinkResult(result);    
  }

  switchFilters(wrapper) {
    wrapper.querySelectorAll('[current-filter]').forEach(el => {
      const currentFilter = this.querySelector(`[current-filter="${el.getAttribute('current-filter')}"]`);
      if (!currentFilter) return;

      currentFilter.innerHTML = el.innerHTML;
    });

    wrapper.querySelectorAll('[filter-list]').forEach(filterList => {
      const filterListId = filterList.getAttribute('filter-list');
      if (!filterListId) return;

      const currentFilterList = this.querySelector(`[filter-list="${filterListId}"]`);
      if (!currentFilterList) return;

      currentFilterList.innerHTML = filterList.innerHTML;
    });
  }

  switchSearchTitle(wrapper) {
    const searchTitle = document.querySelector('[search-title]');
    const wrapperSearchTitle = wrapper.querySelector('[search-title]');
    if (!searchTitle || !wrapperSearchTitle) return;

    searchTitle.innerHTML = wrapperSearchTitle.innerHTML;
  } 
}
if (!customElements.get('cos-collection-grid')) customElements.define('cos-collection-grid', CosCollectionGrid);

class CosFetchLink extends HTMLElement {
  connectedCallback() {
    this.preloadListeners = new Listeners();
    this.loading = false;

    const link = this.querySelector('a');
    if (!link) return;

    link.setAttribute('role', 'button');
    this.url = link.getAttribute('href');
    
    this.closestCollectionGrid = this.closest('cos-collection-grid') || document.querySelector('cos-collection-grid');
    if (!this.closestCollectionGrid) return;

    this.settings = JSON.parse(this.closestCollectionGrid.getAttribute('data-settings')) || {};  

    this.preloadListeners.add(link, 'mouseover', () => this.handlePreload());
    this.preloadListeners.add(link, 'touchstart', () => this.handlePreload());
    link.addEventListener('click', (event) => {
      event.preventDefault();
      this.clicked = true;

      this.handlePreload();
    });
  }

  disconnectedCallback() {
    this.preloadListeners.removeAll();
  }

  async handlePreload() {
    this.preloadListeners.removeAll();
    this.result = this.result || await this.getPage();
    
    if (!this.clicked) return;
    
    window.history.replaceState({}, '', this.url);
    this.closestCollectionGrid.handleFetchLinkResult(this.result);

    this.clicked = false;
  }

  async getPage() {
    return await fetch(`${this.url}${this.url.includes('?') ? '&' : '?'}section_id=${this.settings.sectionId}`).then(response => response.text());
  }
}
if (!customElements.get('cos-fetch-link')) customElements.define('cos-fetch-link', CosFetchLink);

class CosPriceRange extends HTMLElement {
  connectedCallback() { 
    this.listeners = new Listeners();

    this.closestCollectionGrid = this.closest('cos-collection-grid') || document.querySelector('cos-collection-grid');
    if (!this.closestCollectionGrid) return;

    const inputs = this.querySelectorAll('input');

    this.lastCall = 0;

    this.thumbLeft = this.querySelector('.thumb.left');
    this.thumbRight = this.querySelector('.thumb.right');
    this.rangeBetween = this.querySelector('.range-between');
    this.labelMin = this.querySelector('.range-label-start');
    this.labelMax = this.querySelector('.range-label-end');

    [this.inputStart, this.inputEnd] = inputs;
    
    this.setStartValueCustomSlider();
    this.setEndValueCustomSlider();
  
    this.setEvents();
  }

  disconnectedCallback() {
    this.listeners.removeAll();
  }

  setLabelValue(label, input) {
    label.innerHTML = `${formatMoney(parseInt(input.value) * 100, 'amount_no_decimals')}`;
  }

  setStartValueCustomSlider() {
    const maximum = Math.min(parseInt(this.inputStart.value), parseInt(this.inputEnd.value) - 1);
    const percent = ((maximum - this.inputStart.min) / (this.inputStart.max - this.inputStart.min)) * 100;
    this.style.setProperty('--left', percent + '%');
    // this.thumbLeft.style.left = percent + '%';
    // this.rangeBetween.style.left = percent + '%';
  }
  
  setEndValueCustomSlider() {
    const minimun = Math.max(parseInt(this.inputEnd.value), parseInt(this.inputStart.value) + 1);
    const percent = ((minimun - this.inputEnd.min) / (this.inputEnd.max - this.inputEnd.min)) * 100;
    this.style.setProperty('--right', 100 - percent + '%');
    // this.thumbRight.style.right = 100 - percent + '%';
    // this.rangeBetween.style.right = 100 - percent + '%';   
  }

  async handleInputChange() {
    const max = Math.max(parseInt(this.inputEnd.value), parseInt(this.inputStart.value));
    const min = Math.min(parseInt(this.inputStart.value), parseInt(this.inputEnd.value));

    const urlToRemove = this.getAttribute('data-url-to-remove') || window.location.href.split('?')[0] + '?';
    const url = urlToRemove + `${urlToRemove.includes('?') ? '&' : '?'}${this.inputStart.name}=${min}&${this.inputEnd.name}=${max}`;

    this.closestCollectionGrid.onPriceFiterChange(url);
  }
  
  setEvents() {
    this.listeners.add(this.inputStart, 'input', () => {
      this.setStartValueCustomSlider();
      this.setLabelValue(this.labelMin, this.inputStart);      
    });
    this.listeners.add(this.inputEnd, 'input', () => {
      this.setEndValueCustomSlider();
      this.setLabelValue(this.labelMax, this.inputEnd);
    });

    this.listeners.add(this.inputStart, 'change', () => {
      this.handleInputChange();
    });
    this.listeners.add(this.inputEnd, 'change', () => {
      this.handleInputChange();
    });
  
    // add css clases on hover and drag
    this.listeners.add(this.inputStart, 'mouseover', () => {
      this.thumbLeft.classList.add('hover');
    });
    this.listeners.add(this.inputStart, 'mouseout', () => {
      this.thumbLeft.classList.remove('hover');
    });
    this.listeners.add(this.inputStart, 'mousedown', () => {
      this.thumbLeft.classList.add('active');
    });
    this.listeners.add(this.inputStart, 'pointerup', () => {
      this.thumbLeft.classList.remove('active');
    });

    this.listeners.add(this.inputEnd, 'mouseover', () => {
      this.thumbRight.classList.add('hover');
    });
    this.listeners.add(this.inputEnd, 'mouseout', () => {
      this.thumbRight.classList.remove('hover');
    });
    this.listeners.add(this.inputEnd, 'mousedown', () => {
      this.thumbRight.classList.add('active');
    });
    this.listeners.add(this.inputEnd, 'pointerup', () => {
      this.thumbRight.classList.remove('active');
    });

    // Mobile
    this.listeners.add(this.inputStart, 'touchstart', () => {
      this.thumbLeft.classList.add('active');
    });
    this.listeners.add(this.inputStart, 'touchend', () => {
      this.thumbLeft.classList.remove('active');
    });
    this.listeners.add(this.inputEnd, 'touchstart', () => {
      this.thumbRight.classList.add('active');
    });
    this.listeners.add(this.inputEnd, 'touchend', () => {
      this.thumbRight.classList.remove('active');
    });
  }
}
if (!customElements.get('cos-price-range')) customElements.define('cos-price-range', CosPriceRange);